"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cache_1 = require("@ledgerhq/live-network/cache");
const logs_1 = require("@ledgerhq/logs");
const api_1 = require("../api");
const cached_1 = require("../api/cached");
const traced_1 = require("../api/traced");
const bridge_1 = require("./bridge");
const httpRequestLogger = (url, options) => {
    (0, logs_1.log)("network", url, {
        method: options === null || options === void 0 ? void 0 : options.method,
        body: options === null || options === void 0 ? void 0 : options.body,
        params: options === null || options === void 0 ? void 0 : options.params,
    });
};
const getAPI = (0, cache_1.makeLRUCache)((config) => Promise.resolve((0, traced_1.traced)((0, api_1.getChainAPI)(config, httpRequestLogger))), config => config.endpoint, (0, cached_1.minutes)(1000));
const getQueuedAPI = (0, cache_1.makeLRUCache)((config) => getAPI(config).then(api => (0, api_1.queued)(api, 500)), config => config.endpoint, (0, cached_1.minutes)(1000));
const getQueuedAndCachedAPI = (0, cache_1.makeLRUCache)((config) => getQueuedAPI(config).then(api_1.cached), config => config.endpoint, (0, cached_1.minutes)(1000));
exports.default = (0, bridge_1.makeBridges)({
    getAPI,
    getQueuedAPI,
    getQueuedAndCachedAPI,
});
//# sourceMappingURL=js.js.map